import React from 'react'
import { Radar } from '@nivo/radar'
import { COLORS } from '../Reports'
import { TYPE_OF_REVIEWERS } from 'app/constants/reviews'

const theme = {
  axis: {
    ticks: {
      text: {
        fontSize: 12,
      },
    },
  },
  dots: {
    text: {
      fontSize: 14,
    },
  },
}

const LabelComponent = ({ id, anchor }) => {
  let string = id
  const stringLength = string.length
  if (stringLength > 28) {
    string = string.slice(0, 25) + '...'
  } else {
    // need this because Radar can't have 2 or more identical names
    const matchString = string && string.match(/^.+_/)
    string = matchString && matchString[0] ? matchString[0].slice(0, -1) : string
  }
  return (
    <text textAnchor={anchor} style={{ fontSize: '12px', fontFamily: 'sans-serif', fill: 'rgb(51, 51, 51)' }}>
      {string}
    </text>
  )
}

const RadarChart = ({ data, reviewers }) => {
  // this need for removing empty reviewersTypes
  const updatedData = data.map((competency, i) => {
    if (!reviewers[TYPE_OF_REVIEWERS.SUPERIOR]) {
      delete competency.Supervisors
    }
    if (!reviewers[TYPE_OF_REVIEWERS.PEER]) {
      delete competency.Peers
    }
    if (!reviewers[TYPE_OF_REVIEWERS.EMPLOYEE]) {
      delete competency.Direct
    }
    competency.key = `${competency.competency}_${i}`
    return competency
  })
  // this need for removing empty reviewersTypes
  const keys = ['Self']
  if (reviewers[TYPE_OF_REVIEWERS.SUPERIOR]) {
    keys.push('Supervisors')
  }
  if (reviewers[TYPE_OF_REVIEWERS.PEER]) {
    keys.push('Peers')
  }
  if (reviewers[TYPE_OF_REVIEWERS.EMPLOYEE]) {
    keys.push('Direct')
  }
  return (
    <Radar
      data={updatedData}
      keys={keys}
      indexBy="key"
      width={784}
      height={512}
      colors={COLORS}
      maxValue="auto"
      fillOpacity={0}
      margin={{ top: 70, right: 80, bottom: 40, left: 80 }}
      blendMode="normal"
      gridLevels={4}
      gridShape="circular"
      curve="linearClosed"
      borderWidth={2}
      borderColor={{ from: 'color' }}
      gridLabelOffset={36}
      gridLabel={LabelComponent}
      animate
      motionStiffness={90}
      motionDamping={15}
      isInteractive
      theme={theme}
      legends={[
        {
          anchor: 'top-left',
          direction: 'column',
          translateX: -50,
          translateY: -40,
          itemWidth: 80,
          itemHeight: 20,
          itemTextColor: '#999',
          symbolSize: 12,
          symbolShape: 'circle',
          effects: [
            {
              on: 'hover',
              style: {
                itemTextColor: '#000',
              },
            },
          ],
        },
      ]}
    />
  )
}

export default RadarChart
